import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// import 'ag-grid-community/styles/ag-theme-material.css';
import { AG_GRID_LOCALE_KR } from '@ag-grid-community/locale';
import 'css/AgGridTableCustom.css';
import 'css/AgGridTableScrollTop.css';

import { TableContainer } from "@mui/material";
import { Box } from "@mui/system";
import { AgGridReact } from 'ag-grid-react';
import { forwardRef } from 'react';

import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';

// Register all community features
ModuleRegistry.registerModules([AllCommunityModule]);

// Mark all grids as using legacy themes
provideGlobalGridOptions({ theme: "legacy" });

const GridTableMain = forwardRef(({ children, box_style, ...props }, ref) => {
    // 컬럼 정의에 headerTooltip 추가하는 함수
    const processColumnDefs = (columnDefs) => {
        if (!columnDefs) return null;

        const newColumnDefs = [...columnDefs];

        // 각 컬럼에 자동으로 headerTooltip 설정
        newColumnDefs.forEach(colDef => {
            // headerTooltip이 없고 headerName이 있는 경우만 설정
            if (!colDef.headerTooltip && colDef.headerName) {
                colDef.headerTooltip = colDef.headerName;
            }

            // children이 있는 경우 하위 컬럼에도 적용
            if (colDef.children && Array.isArray(colDef.children)) {
                colDef.children.forEach(childColDef => {
                    if (!childColDef.headerTooltip && childColDef.headerName) {
                        childColDef.headerTooltip = childColDef.headerName;
                    }
                });
            }
        });

        return newColumnDefs;
    };

    // 최종 props 준비
    const finalProps = {
        ...props,
        columnDefs: processColumnDefs(props.columnDefs) || props.columnDefs,
        tooltipShowDelay: 0,
    };

    return (
        <TableContainer>
            <Box className="ag-theme-alpine" style={box_style}>
                {/* <Box className="ag-theme-material" style={box_style}> */}
                <AgGridReact
                    ref={ref}
                    localeText={AG_GRID_LOCALE_KR}
                    {...finalProps}
                >
                </AgGridReact>
            </Box>
        </TableContainer>
    );
});

export default GridTableMain;
